module.exports = __webpack_public_path__ + "cc98fbdf134c8110084ac87f3c7193b7.glb";